import styled from '@emotion/styled'

export const AttachmentsSectionWrapper = styled.div``
